// extracted by mini-css-extract-plugin
export default {"container":"UP-z","title":"VP-z","link":"WP-z"};